import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FAZILService } from '../core/services';
import { Invoice } from '../modelo/Invoice';
import { ComprobantesService } from '../services/comprobantes.service';

@Injectable()
export class ProformaResolver implements Resolve<Invoice>{ //interceptor

    constructor(
        private comprobantesService: ComprobantesService,
        private fazilService: FAZILService,
        private router: Router) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        return this.comprobantesService.getProforma(route.params['uuid'])
            .pipe(
                map(
                    data => {
                        if (data) {
                            return data['factura'] ? data['factura'] : data;
                        } else {
                            this.fazilService.irAFactura();
                        }
                    }
                ),
                catchError((err) => this.fazilService.irAInicio())
            );
    }


}